import * as React from 'react'
import * as s from './Avatar.scss'
import * as colors from 'styles/colors-export.css'
import * as sLay from 'styles/modules/layout.scss'
import cn from 'classnames'

const allColors = [
  colors.graph1,
  colors.graph2,
  colors.graph3,
  colors.graph4,
  colors.graph5,
  colors.graph6,
  colors.graph7,
  colors.graph8,
]

export interface IAvatarProps {
  name: string
  style?: object
}

export const Avatar = ({ name, style }: IAvatarProps) => {
  const firstLetterNumber = name.toLowerCase().charCodeAt(0) - 97
  const firstLetterNumberNormalised =
    firstLetterNumber < 24 && firstLetterNumber >= 0 ? firstLetterNumber : 5 // Make sure it is between 0 and 24
  const nameSplit = name.split(' ')
  const initials =
    nameSplit[0] && nameSplit[1] ? nameSplit[0][0] + nameSplit[1][0] : nameSplit[0][0]
  const colourIndex = Math.floor((firstLetterNumberNormalised * allColors.length) / 24)
  return (
    <div
      className={cn(s.avatar, sLay['layout-column'], sLay['layout-align-center-center'])}
      style={{ background: allColors[colourIndex], ...style }}
    >
      {initials}
    </div>
  )
}



// WEBPACK FOOTER //
// src/components/Avatar/Avatar.tsx